import { type Procedencia, type ProcedenciaRequest } from '../types/procedencia';
import { http } from '../../../../api/http';

export class ProcedenciaService {
  private static readonly ENDPOINTS = {
    LIST: '/Catalog/procedencias',
    CREATE: '/Catalog/procedencias',
    DELETE: '/Catalog/procedencias',
  };

  public static async getProcedencias(): Promise<Procedencia[]> {
    try {
      const response = await http.get(this.ENDPOINTS.LIST);
      return response.data;
    } catch (error) {
      console.error('Error fetching procedencias:', error);
      throw error;
    }
  }

  public static async saveProcedencia(request: ProcedenciaRequest): Promise<Procedencia> {
    try {
      const response = await http.post(this.ENDPOINTS.CREATE, request);
      return response.data;
    } catch (error) {
      console.error('Error saving procedencia:', error);
      throw error;
    }
  }

  public static async deleteProcedencia(id: number): Promise<void> {
    try {
      await http.delete(`${this.ENDPOINTS.DELETE}/${id}`);
    } catch (error) {
      console.error('Error deleting procedencia:', error);
      throw error;
    }
  }
}
